import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../../services/api";
import { Box, TextField, Table, TableBody, TableCell, TableHead, TableRow, Typography, TableContainer, Paper, } from "@mui/material";
import { Medicamento } from "./types/typesListaMedicamentos";
import HeaderSession from "../../../utils/headerSession";
import Loading from "../../../load/loading";
import FerramentaNavegacaoExportacao from "../../../utils/paginacao";
import ListaVazia from "../../../utils/listaVazia";

type ConfigLista = {
  nextPage: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  totalItems: number;
};

const TabelaGeral: React.FC = () => {
  const [medicamentos, setMedicamentos] = useState<Medicamento[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [perPage, setPerPage] = useState(50);
  const [order, setOrder] = useState("");
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState<number>(Number(searchParams.get("page")) || 1);
  const navigate = useNavigate();
  const status = searchParams.get("status")

  const [configLista, setConfigLista] = useState<ConfigLista>({
    nextPage: 0,
    hasPreviousPage: false,
    hasNextPage: false,
    totalItems: 0
  });


  useEffect(() => {
    setIsLoading(true);
    api.get(`/medicamento-aims?page=${page}&status=${status ?? ''}&perPage=${perPage}&sortBy=nome:${order}`)
      .then((res) => {
        setConfigLista(res?.data);
        setMedicamentos(res.data.medicamentoAIMs);
      })
      .catch(() => {
      }).finally(() => setIsLoading(false));
  }, [page, perPage, order, status]);


  const medicamentosFiltrados = useMemo(() => medicamentos.filter(medicamento =>
    medicamento?.nome?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  ), [medicamentos, searchTerm]);

  return (
    <Box sx={{ minHeight: '72vh', maxWidth: 1600, mx: 'auto' }}>
      <HeaderSession title={`TABELA DE REGISTO DE MEDICAMENTOS ${status ? status?.toUpperCase() + "S" : ''}`} />

      <Box marginBottom={2} gap={2} display="flex" justifyContent="space-between">
        <TextField
          label="Filtrar por nome ou categoria"
          variant="outlined"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          fullWidth
        />
        
        <button
          color="primary"
          onClick={() => navigate("/admin/registrar-medicamento")}
          style={{
            padding: "12px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            color: " white",
            backgroundColor: "#85287e",
          }}
        >
          Adicionar Medicamento
        </button>
      </Box>

      {medicamentos.length > 0 &&
        <TableContainer sx={{ border: "1px black" }} component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: "#dcdede" }}>
              <TableRow>
                <TableCell><Typography noWrap ><b>Nº</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Nome de marca</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>DCI e dosagem</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Apresentação</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Área terapêutica</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Fabricante</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Titular de AIM</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Número de registo</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Data de registo</b></Typography></TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ border: "1px", borderColor: "black" }}>
              {medicamentosFiltrados.map((medicamento, index) => (
                <TableRow
                  key={medicamento?._id}
                  hover
                  onClick={() => navigate(`/admin/medicamento/${medicamento?._id}`)}
                  sx={{ cursor: "pointer" }}
                >
                  <TableCell>
                    {index + 1}
                  </TableCell>
                  <TableCell>{medicamento?.nome}</TableCell>
                  <TableCell>
                    {medicamento?.dciDosagem}
                  </TableCell>
                  <TableCell>
                    {medicamento?.apresentacao}
                  </TableCell>
                  <TableCell>
                    {medicamento?.areaTerapeutica}
                  </TableCell>
                  <TableCell>
                    {medicamento?.fabricante}
                  </TableCell>
                  <TableCell>
                    {medicamento?.titularAIM}
                  </TableCell>
                  <TableCell>
                    {medicamento?.numeroRegisto}
                  </TableCell>
                  <TableCell>
                    {new Date(
                      medicamento?.dataRegisto ?? ""
                    ).toLocaleDateString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <FerramentaNavegacaoExportacao
            configLista={configLista}
            lista={medicamentosFiltrados}
            page={page}
            perPage={perPage}
            setPage={setPage}
            setPerPage={setPerPage}
            setOrder={setOrder}
          />
        </TableContainer>
      }

      {isLoading && <Loading text={""} focus={false} />}

      {medicamentos.length < 1 && <ListaVazia text={''} />}

    </Box>
  );
};

export default TabelaGeral;
